module.exports = __webpack_public_path__ + "static/media/brana.3d7419ca.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pictures/brana.jpg
// module id = 317
// module chunks = 0